var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23611 6.1347C6.71115 5.58965 7 4.86988 7 4.08082C7 2.37933 5.65685 1 4 1C2.34315 1 1 2.37933 1 4.08082C1 5.78231 2.34315 7.16164 4 7.16164C4.8885 7.16164 5.68679 6.76499 6.23611 6.1347ZM6.23611 6.1347L10 10",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-search.02ad43fa.svg";
export { ForwardRef as ReactComponent };